module.exports = __webpack_public_path__ + "static/media/saved-recipes.59c8777c.png";